export enum SORTABLE_PROPERTIES {
	CID = "CID",
	RTT = "RTT",
	UPTIME = "UPTIME",
	LAST_ACTIVITY = "LAST ACTIVITY",
	IDLE_TIME= "IDLE TIME",
	SUBSCRIPTIONS = "SUBSCRIPTIONS",
	MESSAGES_OUT = "MESSAGES OUT",
	MESSAGES_IN = "MESSAGES IN",
	DATA_SIZE_OUT = "DATA OUT",
	DATA_SIZE_IN = "DATA IN",
	PENDING_DATA = "PENDING DATA",
	CONNECTION_START = "CONNECTION START",
	NAME = "NAME",
	LANGUAGE = "LANGUAGE",
}